export const normalizeText = (value = "") =>
  value
    .toString()
    .normalize("NFD")                // separa acentos
    .replace(/[\u0300-\u036f]/g, "") // elimina acentos
    .toLowerCase()
    .trim();
